enum FeatureFlags {
  ENABLE_HATS = 'enableHaTS',
  DISABLE_RECOMMENDATIONS = 'disableRecommendations',
  DISABLE_ADS = 'disableAds',
  ENABLE_BRANDED_LISTING = 'enableBrandedListing',
  ENABLE_GGA_MAUR = 'enableGgaMaur',
  ENABLE_NEIGHBOURHOOD_WEBSEARCH = 'enableNeighbourhoodWebSearch',
  ENABLE_CONTACT_REQUEST_EMAIL_VERIFICATION = 'enableContactRequestEmailVerification',
  ENABLE_PARTNER_BADGE = 'enablePartnerBadge',
}

export default FeatureFlags;
